import { ProyectoService } from '../../services/proyecto.service';
import { AreaElementoService } from '../../services/area.elemento.service';
import { AreaService } from './../../../catalogos-admin/services/area.service';
import { IpPublicService } from '../../../../services/ip-public.service';
import { Component, ChangeDetectorRef, OnDestroy, OnInit, ViewChild, NgZone, } from '@angular/core';
import { FormBuilder, Validators, FormGroup, UntypedFormGroup, FormArray } from '@angular/forms';
import { AlertService } from '../../../../services/alert.service';
import { ModalService } from '../../../../services/modal.service';
import { DataTableDirective } from 'angular-datatables';
import { ObjetivoService } from '../../services/objetivo.service';
import { EstrategiasService } from '../../services/estrategias.service';
import { ComunService } from 'src/app/modulos/catalogos-proces/services/comun.service';
import { EquipoGerencialService } from 'src/app/modulos/catalogos-proces/services/equipo.gerencial.service';
import { Subject, forkJoin, map, mergeMap } from 'rxjs';
import { EstrategiaObjetivoService } from '../../services/estrategia-objetivo.service';
import { ParticipanteElementoService } from '../../services/participante.elemento.service';
import { DatePipe } from '@angular/common';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { IndicadoresService } from '../../services/indicadores.service';
import { EtapaService } from '../../services/etapa.service';
import { RiesgosService } from '../../services/riesgos.service';
import { validadorFechaIntervalo } from 'src/app/helpers/validator-form';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { TreeNode } from 'primeng/api';
import { UnidadesSiipneService } from 'src/app/services/unidades-siipne.service';
import { ResumenEjecutivoService } from '../../services/resumen-ejecutivo.service';
import { HitoService } from '../../services/hito.service';
import { UsuarioRedux } from 'src/app/models/usuario.model';
import { UserService } from 'src/app/modulos/admin/services/user.service';


@Component({
  selector: 'app-proyecto',
  templateUrl: './proyecto.component.html',
  styleUrls: ['./proyecto.component.css'],
})
export class ProyectoComponent implements OnInit, OnDestroy {
  isChecked: boolean = false;

  seleccionados: any[] = [];
  elementosDiferentes: any[] = [];
  vector1: any[] = [];
  vector2: any[] = [];
  breadCrumbItems = [
    { label: 'Formulación planes' },
    { label: 'Elementos' },
    { label: 'Proyectos', active: true },
  ];
  @ViewChild('modalChild') myModal: any;
  public formProyecto!: UntypedFormGroup;
  public currentUserRedux: UsuarioRedux = null;
  public formSubmitted = false;
  public currentAmbiente: any;
  public ipAddress!: string;
  public buffer: any;
  public dataObjetivo: any = []; // trae data de objetivos
  public dataProyectos: any = [];
  public dataEstrategias: any = [];
  public dataAreas: any; // trae data de areas del Ambiente
  public dataEquipoGerencial: any;
  public dataAreasProcess!: any;
  public dataAreasChecked: any = []; //data para Area
  public dataCatComun!: any; // trae data catalogo comun
  public dataTipoProyecto!: any; // trae data catalogo comun tipo de proyecto
  public dataViabilidadTecnica!: any; // trae data catalogo comun viabilidad tecnica
  public dataLiderProyecto: any = [];
  public participanteElemento: any = [];
  public dataParticipanteElem!: any;
  public dataTipoParticpacion!: any;
  public dataObjetivoProyecto!: any;
  public nombreUnidad!: any;
  private idDeleteRegister: number = 0;
  public estadoActivo: number = 1;
  public selectItems: any[] = [];
  public nombreRuta: any = '';
  public nameModal: string = 'PROYECTOS';
  public nameModal1: string = 'ETAPAS';
  public modalResumenEjecutivo: string = 'RESUMEN EJECUTIVO';
  public desripcionProyecto!: any;
  public idSprAmbiente!: number;
  public idSprUsuario!: number;
  public idSprProyecto!: number;
  public idSprNivel: number = 0;
  public nivelSelect!: number;
  public dataResponsable: any = []; //data para Titluares unidad
  public contador = 3000;
  public textoDescripcionValue = '';
  public dataOrdenadaMeses: any;
  public resultadoFinalMesesInicioFin: any[] = [];
  public resultadoFinalMesesInicioFinActualizar: any[] = [];
  public datosSeleccionados: any[] = [];
  public dataAreasAmbientes: any[] = [];
  public datosSeleccionadosDesdeBack: any[] = [];
  public datosNoSeleccionados: any[] = [];
  public datos: any[] = [];
  public idSprParticipanteElemento: number = 0;
  public dataGetAres = []
  public opciones: any[] = []
  public dataAreaElement: any[] = [];

  public idSprNivelN5 = ConstantsCatalogosIdService.ID_COMUNES_NIVEL_5;
  public idSprComunTipoCliente = ConstantsCatalogosIdService.ID_COMUNES_TIPO_CLIENTE; // id de tipos de clientes del catalogo comun
  public idSprComunTipoProyecto = ConstantsCatalogosIdService.ID_COMUNES_TIPO_PROYECTO; // id de tipos de proyecto del catalogo comun
  public idSprComunViabilidadTecnica = ConstantsCatalogosIdService.ID_COMUNES_VIABILIDAD_TECNICA; //id de viabilidad técnica del catalago comun
  public idSprComunEquipoProyectos = ConstantsCatalogosIdService.ID_COMUNES_EQUIPO_PROYECTOS; // id de rol de lider del catalago comun
  public idSprComunTipoParticipante = ConstantsCatalogosIdService.ID_COMUNES_TIPO_PARTICIPANTE; // id para guardar unicamente de participantes
  public idSprComunResponsable = ConstantsCatalogosIdService.ID_COMUNES_RESPONSABLE; // id para guardar unicamente de reesponsable(titular)
  public idSprComunLiderProyecto = ConstantsCatalogosIdService.ID_COMUNES_LIDER_PROYECTO; // id para guardar unicamente de lider de proyecto
  public fechaInicioResumenEjecutivo = ConstantsCatalogosIdService.FECHARESUMENEJECUTIVO;
  public inputs = [
    {
      nombre: '',
      cedula: '',
      idSprTipoParticipante: this.idSprComunEquipoProyectos,
    },
  ];
  public hoy = new Date();
  public pipe = new DatePipe('en-US');
  public etapa = [];
  public participantesNuevos = [];
  public inputsAnteriores = [];
  public participanteElementoAeliminar = [];
  public guardarEquipoGerencialSeleccionado: any;
  public patrocinadorOriginal: any;
  dataUserSiipne: any;
  public planAnioSeleccionadoRedux: any = null;
  public proyectoActual: any = null;
  public idSprPlanInstitucionalRedux: any;
  public objetivoSeleccionadoCombo: any = null;
  public idSprPlanAnio: number = 0;
  public dataAreasElementos: any[];
  public datosResumen: any[];
  public editMeses: any[];
  public dataMesesNoEstan: any[];
  public fechaIniciObjetivo: any;
  public fechaFinObjetivo: any;
  public nombreParticipante: any;
  public apellidoParticipante: any;
  public gradoParticipante: any;
  public continuar: any;
  public continuar2: any;
  public resultadoFechasInicio: any[];
  public resultadoFechasActualizar: any[];
  public resumenEjecutivoGuardado: any[];

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  isDtInitialized: boolean = false;

  unidades: TreeNode[];
  selectedFile: TreeNode;
  formAmbiente: FormGroup;

  public months: any;
  public monthsFechasInicioFin: any;
  public idEstrategia: any;

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  readonly constant = ConstantsCatalogosIdService;

  constructor(
    private ngZone: NgZone,
    private fb: FormBuilder,
    private proyectoService: ProyectoService,
    private alertService: AlertService,
    private ip: IpPublicService,
    public modal: ModalService,
    private objetivoService: ObjetivoService,
    private comunService: ComunService,
    private areaServcie: AreaService,
    private equipoGerencialService: EquipoGerencialService,
    private userService: UserService,
    private areaELemService: AreaElementoService,
    private estrategiaService: EstrategiasService,
    private estrategiaObjetivosService: EstrategiaObjetivoService,
    private participanteElementoService: ParticipanteElementoService,
    private indicadorService: IndicadoresService,
    private etapaService: EtapaService,
    private hitoService: HitoService,
    private riesgoService: RiesgosService,
    private unidadesSiipneService: UnidadesSiipneService,
    private cdr: ChangeDetectorRef,
    private resumenEjecutivoService: ResumenEjecutivoService,
    public store: Store<AppState>,
    private alert: AlertService
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentAmbiente = JSON.parse(this.buffer);
    this.nombreUnidad = this.currentAmbiente.nombreUnidad;
    this.selectItems = [
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];

  }
  ngOnInit(): void {
    this.store.select('globalApp').subscribe((response) => {
      this.planAnioSeleccionadoRedux = response.planAniosSeleccionado;
      this.idSprPlanAnio = response.planAniosSeleccionado.idSprPlanAnio;
      this.fechaIniciObjetivo = response.planAniosSeleccionado.fechaInicio;
      this.fechaFinObjetivo = response.planAniosSeleccionado.fechaFin;
      this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
      this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
      this.nivelSelect = response.ambienteSeleccionado.nivel.idSprNivel;
      this.initApp();
    });
    this.store.select('usuarioApp').subscribe((response) => {
      this.currentUserRedux = response.currentUser;
      this.idSprUsuario = response.currentUser.idSprUsuario;
    });
  }

  initApp() {
    this.setFormProyecto();
    this.setDataTable();
    this.getIpPublic();
    this.getAreas();
    this.listEquipoGerencial();
    this.listTipoProyecto();
    this.listTipoCliente();
    this.listViabilidadTecnica();
    this.listAreas();
    this.getTreeUnidadesSiipne();
    this.getDataAll();
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }
  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }


  setFormProyecto() {
    this.formProyecto = this.fb.group({
      idSprProyecto: [],
      idSprArea: new FormArray([]),
      idSprObjetivo: ['', [Validators.required]],
      idSprEstrategia: ['', [Validators.required]],
      idSprTipoProyecto: ['', [Validators.required]],
      idSprAmbiente: ['', [Validators.required]],
      idSprTitular: ['', [Validators.required]],
      idSprViabilidadTecnica: ['', [Validators.required]],
      idSprParticipanteElemento: [],
      idSprEquipoGerencialAnterior: [],
      idSprEquipoGerencial: ['', [Validators.required]],
      localidadImpacto: ['', [Validators.required]], //para la localidad de impacto
      nombreProyecto: ['', [Validators.required]],
      descripcion: [''],
      fechaInicio: ['', [Validators.required, validadorFechaIntervalo(this.fechaIniciObjetivo, this.fechaFinObjetivo),],],
      fechaFin: ['', [Validators.required, validadorFechaIntervalo(this.fechaIniciObjetivo, this.fechaFinObjetivo),],],
      beneficiosCualitativos: [''],
      restricciones: [''],
      numContratoPrincipal: [''],
      idSprTipoCliente: ['', [Validators.required]],
      objetivoGeneral: ['', [Validators.required]],
      objetivoEspecifico: ['', [Validators.required]],
      estado: ['1', [Validators.required]],
      /*set participantes */
      cedula: ['', [Validators.required]],
      grado: ['', [Validators.required]],
      nombreParticipante: ['', [Validators.required]],
      cargoFuncion: ['', [Validators.required]],
      fechaInicioParticipante: ['', [Validators.required]],
      fechaFinParticipante: ['', []],
      estadoParticipa: ['', []],
      /*Fin set participantes */
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  getDataAll() {
    forkJoin([
      this.objetivoService.list('?idSprAmbiente=' + this.idSprAmbiente + '&idSprPlanAnio=' + this.idSprPlanAnio + '&estado=' + this.estadoActivo),
      this.proyectoService.list(),
      this.areaELemService.list('?estado=' + this.estadoActivo),
    ])
      .pipe(
        map(([objetivo, proyecto, dataAreaElement]) => {
          this.dataObjetivo = objetivo;
          this.dataProyectos = proyecto;
          this.dataAreaElement = dataAreaElement;
          this.mapeoObjetivoProyecto();
        })
      )
      .subscribe();
  }

  ///////DATA MAPEADA DE PROYECTOS CON AÑOS /////////////////

  mapeoObjetivoProyecto() {
    let dataProcess = [];
    let areaProyecto: any = [];
    for (let i = 0; i < this.dataObjetivo.length; i++) {
      for (let j = 0; j < this.dataProyectos.length; j++) {
        if (this.dataObjetivo[i].idSprObjetivo === this.dataProyectos[j].idSprObjetivo && this.dataObjetivo[i].estado == 1
        ) {
          for (let k = 0; k < this.dataAreaElement.length; k++) {
            if (this.dataAreaElement[k].idSprProyecto == this.dataProyectos[j].idSprProyecto) {
              areaProyecto.push({
                idSprArea: this.dataAreaElement[k].idSprArea,
                //nombre: this.dataAreaElement[k].nombre,
              });
            }
          }
          dataProcess.push({
            idSprProyecto: this.dataProyectos[j].idSprProyecto,
            idSprObjetivo: this.dataProyectos[j].idSprObjetivo,
            idSprEstrategia: this.dataProyectos[j].idSprEstrategia,
            idSprAmbiente: this.dataProyectos[j].idSprAmbiente,
            idSprTitular: this.dataProyectos[j].idSprTitular,
            idSprTipoProyecto: this.dataProyectos[j].idSprTipoProyecto,
            idSprViabilidadTecnica: this.dataProyectos[j].idSprViabilidadTecnica,
            idSprTipoCliente: this.dataProyectos[j].idSprTipoCliente,
            localidadImpacto: this.dataProyectos[j].localidadImpacto,
            nombreProyecto: this.dataProyectos[j].nombreProyecto,
            objetivoGeneral: this.dataProyectos[j].objetivoGeneral,
            objetivoEspecifico: this.dataProyectos[j].objetivoEspecifico,
            descripcion: this.dataProyectos[j].descripcion,
            numContratoPrincipal: this.dataProyectos[j].numContratoPrincipal,
            beneficiosCualitativos: this.dataProyectos[j].beneficiosCualitativos,
            restricciones: this.dataProyectos[j].restricciones,
            fechaInicio: this.dataProyectos[j].fechaInicio,
            fechaFin: this.dataProyectos[j].fechaFin,
            estado: this.dataProyectos[j].estado,
            areas: areaProyecto,
          });
          areaProyecto = []
        }
      }
    }
    this.dataObjetivoProyecto = dataProcess;
    this.reDrawDataTable();
  }

  reDrawDataTable() {
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api | undefined) => {
        if (dtInstance) {
          dtInstance.destroy();
          this.dtTrigger.next(null);  // Cambio aquí, proporciona null como argumento
        }
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);  // Cambio aquí, proporciona null como argumento
    }
  }

  get proyectoForm() {
    return this.formProyecto.controls;
  }


  ///////METODO PARA OBTENER LAS ESTRATEGIAS RELACIONADAS A LOS OBJETIVOS /////////////////
  obtenerEstategias(event: any) {
    this.dataEstrategias = []
    if (event) {
      this.objetivoSeleccionadoCombo = event;
      this.estrategiaObjetivosService.list('?idSprObjetivo=' + event).subscribe(data => {
        data.map(estrategiaObjetivo => {
          this.estrategiaService.getById(estrategiaObjetivo.idSprEstrategia).subscribe(estrategia => {
            this.dataEstrategias.push(estrategia)
          })
        })
      })
    }
    this.cdr.detectChanges();
  }


  //  ////////////TRAE DATOS DE EQUIPO GERENCIAL/////////
  listEquipoGerencial() {
    this.equipoGerencialService.list('?idSprAmbiente=' + this.idSprAmbiente).subscribe((dataEquipoGerencial) => {
      this.dataEquipoGerencial = dataEquipoGerencial;
      this.getTipoParticipacion();
    });
  }



  /////////////TRAE DATOS TIPO PARTICIPANTE DEL CATALOGO COMUN///////////
  getTipoParticipacion() {
    this.comunService.list('?spr_idSprComun=' + this.idSprComunTipoParticipante)
      .subscribe((respTipoParticipa) => {
        this.dataTipoParticpacion = respTipoParticipa;
        this.mapeoEquipoGerencialTipoParticipa();
      });
  }

  ////////TRAE DATOS DEL CATALOGO COMUN TIPO DE CLIENTES//////////////
  listTipoCliente() {
    this.comunService.list('?spr_idSprComun=' + this.idSprComunTipoCliente).subscribe((resp) => {
      this.dataCatComun = resp;
    });
  }

  ///////////TRAE DATOS DEL CATALOGO COMUN TIPO DE PROYECTOS/////////////////
  listTipoProyecto() {
    this.comunService
      .list('?spr_idSprComun=' + this.idSprComunTipoProyecto)
      .subscribe((resp) => {
        this.dataTipoProyecto = resp;
      });
  }
  ////////////TRAE DATOS DEL CATALOGO COMUN VIABILIDAD TECNICA//////////////////
  listViabilidadTecnica() {
    this.comunService
      .list('?spr_idSprComun=' + this.idSprComunViabilidadTecnica)
      .subscribe((resp) => {
        this.dataViabilidadTecnica = resp;
      });
  }

  /////////////TRAE DATOS DE ETAPA//////////////////
  etapaInit(obj: any) {
    this.desripcionProyecto = obj.nombreProyecto;
    this.etapa = obj;
    this.proyectoActual = obj;
    this.openModalEtapa();
  }

  resumenEjecutivo(obj: any) {
    this.desripcionProyecto = obj.nombreProyecto;
    this.etapa = obj;
    this.proyectoActual = obj;
    this.etapaService.list('?idSprProyecto=' + obj.idSprProyecto).subscribe({
      next: (etapasProyectos) => {
        this.procesarEtapasProyectos(etapasProyectos);
      },
      error: (error) => {
        this.alertService.error('Error', 'Al traer las etapas');
      },
    });
  }

  procesarEtapasProyectos(etapasProyectos: any[]): void {
    if (etapasProyectos.length > 0) {
      if (etapasProyectos.length === 5) {
        const observables = etapasProyectos.map((etapaProyecto) => {
          const idSprEtapaProyecto = etapaProyecto.idSprEtapa;
          return this.hitoService.list('?idSprEtapa=' + idSprEtapaProyecto);
        });
        forkJoin(observables).subscribe({
          next: (results: any[]) => {
            this.verificarEtapasCumplen(etapasProyectos, results)
              .then((cumplen) => {
                if (cumplen) {
                  this.openResumenEjecutivo();
                } else {
                  this.alertService.warning(
                    'Atención',
                    'Alguna etapa no cumple'
                  );
                }
              })
              .catch((error) => {
                console.error('Error al procesar las etapas:', error);
                this.alertService.error(
                  'Error',
                  'Error al procesar las etapas'
                );
              });
          },
          error: (error) => {
            console.error('Error al procesar las etapas:', error);
            this.alertService.error('Error', 'Error al procesar las etapas');
          },
        });
      } else {
        this.alertService.warning(
          'Atención',
          'Primero: Debe ingresar las etapas del proyecto y posterior los hitos de cada una de las etapas con Cumplimiento SI'
        );
      }
    } else {
      this.alertService.warning('Atención', 'No tiene ingresado ninguna etapa');
    }
  }

  async verificarEtapasCumplen(
    etapasProyectos: any[],
    results: any[]
  ): Promise<boolean> {
    try {
      for (const [index, etapaProyecto] of etapasProyectos.entries()) {
        const maximoHitos = etapaProyecto['maximoHitos'];
        const hitos = results[index];
        const cantidadHitos = hitos.length;
        if (!(cantidadHitos >= maximoHitos)) {
          return false;
        }
      }
      return true;
    } catch (error) {
      console.error('Error:', error);
      return false;
    }
  }
  //////////////////////////Para el árbol de unidades //////////////////////////

  getTreeUnidadesSiipne() {
    this.unidadesSiipneService.listParents().subscribe((resp: TreeNode[]) => {
      this.unidades = resp;
      this.unidades.forEach((node) => {
        this.unidadesSiipneService
          .listChilds(node.data)
          .subscribe((respChild: TreeNode[]) => {
            node.children = respChild;
          });
      });
    });
  }

  nodeSelect(evt) {
    (this.nombreRuta = this.nombreRuta + (' / ' + evt.node.label)),
      this.formProyecto.patchValue({
        idDgpUnidad: evt.node.data,
        localidadImpacto: this.nombreRuta,
      });
  }

  nodeExpand(event) {
    if (event.node) {
      this.unidadesSiipneService
        .listChilds(event.node.data)
        .subscribe((resp) => {
          event.node.children = resp;
        });
    }
  }

  //////////////////////////FIN árbol de unidades //////////////////////////

  onChangeAreas(event: any, id: any) {
    let indice = -1;
    for (let i = 0; i < this.opciones.length; i++) {
      if (this.opciones[i].idSprArea === id) {
        indice = i;
        break; // Si encuentra sal del bucle
      }
    }
    if (indice === -1) {
      this.opciones.push({
        idSprArea: id,
        checked: event.target.checked,
      });
    } else {
      this.opciones.splice(indice, 1);
    }
  }

  setDataAreasCheck(dataRow: any) {
    let areasFixed = this.dataGetAres;
    let checked: boolean = false;
    for (let i = 0; i < this.dataGetAres.length; i++) {
      for (let j = 0; j < dataRow.length; j++) {
        if (this.dataGetAres[i].idSprArea === dataRow[j].idSprArea) {
          checked = true;
        }
      }
      areasFixed[i].checked = checked;
      checked = false;
    }
  }


  actualizarSeleccion(event: any, dato: any) {
    const checkbox = event.target;
    const isChecked = checkbox.checked;
    if (isChecked && !this.datosSeleccionados.some((item) => item.idSprArea === dato.idSprArea)) {
      // Checkbox seleccionado y no está en la lista de datos seleccionados, agregarlo
      this.datosSeleccionados.push({ idSprArea: dato.idSprArea, isChecked: true });
    } else if (!isChecked) {
      // Checkbox deseleccionado, eliminar de la lista de datos seleccionados
      this.datosSeleccionados = this.datosSeleccionados.filter((item) => item.idSprArea !== dato.idSprArea);
      this.datosSeleccionados.push({ idSprArea: dato.idSprArea, isChecked: false });
    } else if (isChecked && this.datosSeleccionados.some((item) => item.idSprArea === dato.idSprArea)) {
      // Checkbox seleccionado y no está en la lista de datos seleccionados, agregarlo
      this.datosSeleccionados = this.datosSeleccionados.filter((item) => item.idSprArea !== dato.idSprArea);
      this.datosSeleccionados.push({ idSprArea: dato.idSprArea, isChecked: true });
    }
    this.actualizarDatosNoSeleccionados();
  }

  esSeleccionado(dato: any): boolean {
    return this.datosSeleccionados.some((seleccionado) => seleccionado.idSprArea === dato.idSprArea);
  }

  actualizarDatosNoSeleccionados() {
    this.datosNoSeleccionados = this.dataAreasAmbientes.filter(
      (dato) => !this.datosSeleccionados.some((seleccionado) => seleccionado.idSprArea === dato.idSprArea));
  }

  // ////////////TRAE DATOS DE AREAS/////////////////////
  listAreas() {
    this.areaServcie.list('?idSprAmbiente=' + this.idSprAmbiente).subscribe((resp) => {
      this.dataAreas = resp.map((x: any) => {
        x.isChecked = false;
        return x;
      });
      this.dataAreasProcess = this.dataAreas;
      for (let j = 0; j < this.datosSeleccionados.length; j++) {
        for (let i = 0; i < this.dataAreasProcess.length; i++) {
          if (this.dataAreasProcess[i].idSprArea == this.datosSeleccionados[j].idSprArea) {
            // Agregar la propiedad idSprAreaElemento al objeto
            this.dataAreasProcess[i].idSprAreaElemento = this.datosSeleccionados[j].idSprAreaElemento;
          }
        }
      }
    });
  }

  getAreas() {
    this.areaServcie.list('?idSprAmbiente=' + this.idSprAmbiente).subscribe(
      resp => {
        this.dataGetAres = resp
      }
    )
  }

  setDataAreasElementosSelected(idSprProyecto: number) {
    this.areaELemService.list(`?idSprProyecto=${idSprProyecto}&delLog=N`)
      .subscribe({
        next: (response) => {
          this.datosSeleccionados = response;
        },
        error: (error) => { },
      });
    for (let j = 0; j < this.datosSeleccionados.length; j++) {
      for (let i = 0; i < this.dataAreasProcess.length; i++) {
        if (this.dataAreasProcess[i].idSprArea == this.datosSeleccionados[j].idSprArea) {
          this.dataAreasProcess[i].isChecked = true;
          this.dataAreasProcess[i].idSprAreaElemento = this.datosSeleccionados[j].idSprAreaElemento;
        }
      }
    }
  }

  ////////////////**Fin de areas*//////////////////

  /////////CONTADOR DE CARACTER//////////
  onKey(event: Event) {
    let maxLength = 3000;
    let strLength = this.textoDescripcionValue.length;
    let charRemain = maxLength - strLength;
    if (charRemain < 0) {
      document.getElementById('contador').innerHTML =
        '<span style="color: red;"> Ha superado el límite de ' +
        maxLength +
        ' characters</span>';
    } else {
      document.getElementById('contador').innerHTML =
        charRemain + ' caracteres restantes';
    }
    this.contador = charRemain; // Actualizar el contador cada vez que se pulsa una tecla
  }
  ////*Fin de contador//////////
  ///////////////////BUSCADOR POR CEDULA /////////////////
  buscaPersona() {
    if (this.validarCedula(this.formProyecto.value.cedula)) {
      try {
        if (this.formProyecto.invalid) {
          this.userService.getPersonaSiipne(this.formProyecto.value.cedula)
            .subscribe((response) => {
              this.ngZone.run(() => {
                this.dataUserSiipne = response;
                let continuar2: string[] = this.continuar2 || []; // Inicializar si es undefined
                this.continuar2 = this.continuar2 || []; // Inicializar si es undefined
                if (this.dataUserSiipne.length < 0) {
                  this.alertService.warning(
                    'No existe usuario con esta cédula.',
                    'Atención'
                  );
                } else {
                  this.nombreParticipante = this.dataUserSiipne.nombres;
                  this.apellidoParticipante = this.dataUserSiipne.apellidos;
                  this.gradoParticipante = this.dataUserSiipne.grado;
                  this.continuar = `${this.gradoParticipante}. ${this.apellidoParticipante} ${this.nombreParticipante}`;
                  this.continuar2 = [this.continuar];
                }
                this.cdr.detectChanges(); // Forzar actualización de la vista
              });
            });
          return;
        } else {
          return;
        }
      } catch { }
    }
  }


  validarCedula(cedula: string): boolean {
    if (cedula == null) {
      this.alertService.warning(
        'Atención!',
        'Debe ingresar el número de cédula'
      );
      return false;
    }
    if (cedula.length < 10) {
      this.alertService.warning(
        'Atención!',
        'El número de cédula debe tener 10 digitos'
      );
      return false;
    }
    return true;
  }
  //////////////////////FIN*////////////////////////

  ///////DATA MAPEADA DE EQUIPO DE PROYECTO CON TIPO DE PARTICIPANTE/////////////////
  mapeoEquipoGerencialTipoParticipa() {
    let dataProcess = [];
    let titulares = [];
    for (let i = 0; i < this.dataEquipoGerencial.length; i++) {
      for (let j = 0; j < this.dataTipoParticpacion.length; j++) {
        if (
          this.dataEquipoGerencial[i].idSprTipoParticipante === this.dataTipoParticpacion[j].idSprComun &&
          this.dataEquipoGerencial[i].estado == 1 && this.dataEquipoGerencial[i].idSprTipoParticipante == this.idSprComunLiderProyecto) {
          dataProcess.push({
            idSprEquipoGerencial: this.dataEquipoGerencial[i].idSprEquipoGerencial,
            nombres: this.dataEquipoGerencial[i].gradoNombres,
            cedula: this.dataEquipoGerencial[i].cedula,
            cargoFuncion: this.dataEquipoGerencial[i].cargoFuncion,
            participacion: this.dataTipoParticpacion[j].nombre,
          });
        }
        if (
          this.dataEquipoGerencial[i].idSprTipoParticipante === this.dataTipoParticpacion[j].idSprComun && this.dataEquipoGerencial[i].estado == 1 && this.dataEquipoGerencial[i].idSprTipoParticipante == this.idSprComunResponsable
        ) {
          titulares.push({
            idSprTitular: this.dataEquipoGerencial[i].idSprEquipoGerencial,
            nombres: this.dataEquipoGerencial[i].gradoNombres,
            cedula: this.dataEquipoGerencial[i].cedula,
            cargoFuncion: this.dataEquipoGerencial[i].cargoFuncion,
            participacion: this.dataTipoParticpacion[j].nombre,
          });
        }
      }
    }
    this.dataLiderProyecto = dataProcess;
    this.dataResponsable = titulares;
  }

  //////////////METODO PARA CREAR PARTICIPANTES///////////
  crearParticipantes(idSprProyecto: number, fechaInicio, FechaFin) {
    this.participantesNuevos.forEach((participante) => {
      let equipoGerencial = {
        idSprAmbiente: this.idSprAmbiente,
        idSprTipoParticipante: this.idSprComunEquipoProyectos,
        cedula: participante.cedula,
        cargoFuncion: participante.cargoFuncion,
        gradoNombres: participante.nombre,
        fechaInicio: fechaInicio,
        fechaFin: FechaFin,
        estado: participante.estadoParticipa,
        ip: this.ipAddress,
        usuario: this.idSprUsuario,
      };

      this.equipoGerencialService.create(equipoGerencial).subscribe({
        next: (equipoGerencialCreado) => {
          let participanteElemento = {
            idSprProyecto: idSprProyecto,
            fechaInicio: fechaInicio,
            fechaFin: FechaFin,
            estado: participante.estadoParticipa,
            ip: this.ipAddress,
            usuario: this.idSprUsuario,
            idSprEquipoGerencial: equipoGerencialCreado.idSprEquipoGerencial,
          };
          this.participanteElementoService
            .create(participanteElemento)
            .subscribe({
              next: () => { },
              error: () => {
                this.equipoGerencialService
                  .delete(equipoGerencialCreado)
                  .subscribe();
              },
            });
        },
        error: (error) => { },
      });
    });
  }

  pushParticipante() {
    if (this.formProyecto.controls['cedula'].invalid) {
      this.alertService.createError();
      return;
    }
    this.participantesNuevos.push({
      nombre: `${this.gradoParticipante}. ${this.apellidoParticipante} ${this.nombreParticipante}`,
      cedula: this.formProyecto.value.cedula,
      cargoFuncion: this.formProyecto.value.cargoFuncion,
      fechaInicial: this.formProyecto.value.fechaInicio,
      fechaFinal: this.formProyecto.value.fechaFinParticipante,
      estadoParticipa: 1,
    });

    this.formProyecto.controls['nombreParticipante'].reset();
    this.formProyecto.controls['cedula'].reset();
    this.formProyecto.controls['cargoFuncion'].reset();
    this.formProyecto.controls['fechaInicioParticipante'].reset();
    this.formProyecto.controls['fechaFinParticipante'].reset();
    this.formProyecto.controls['estadoParticipa'].reset();
  }

  removeInputAnteriores(index: number, obj: any) {
    this.participanteElementoAeliminar.push(obj.participanteElemento);
    this.inputsAnteriores.splice(index, 1);
  }
  /////////*Fin de metodo participante*/////////////

  onSubmit() {
    this.formSubmitted = true;
    this.onKey(null);
    this.formProyecto.value.idSprAmbiente = this.idSprAmbiente;
    this.formProyecto.value.usuario = this.idSprUsuario;
    this.formProyecto.value.ip = this.ipAddress;
    this.formProyecto.value.idSprObjetivo = this.formProyecto.value.idSprObjetivo;
    this.formProyecto.value.localidadImpacto = this.formProyecto.value.localidadImpacto;
    let stateInsert: boolean = false;
    let idSprProyectoInsertado: number = 0;
    let idSprProyecto = this.formProyecto.value.idSprProyecto;
    let idSprUsuario = this.idSprUsuario;
    let fechaInicial = this.formProyecto.value.fechaInicio;
    let fechaFinal = this.formProyecto.value.fechaFin;

    this.getMonths(fechaInicial, fechaFinal);
    if (fechaInicial > fechaFinal) {
      this.alertService.fechaError();
      return
    }
    if (this.formProyecto.value.idSprProyecto == null) {
      let idsAreas = this.opciones;
      this.formProyecto.value.fechaInicio = fechaInicial;
      this.formProyecto.value.fechaFin = fechaFinal;

      if (this.idSprNivelN5 == this.idSprNivel) {
        this.formProyecto.value.idSprEstrategia = null;
      }

      this.proyectoService.create(this.formProyecto.value).subscribe(
        (dataProyectoResponse) => {
          let fechaInicio = this.formProyecto.value.fechaInicio;
          let fechaFin = this.formProyecto.value.fechaFin;
          this.validacionFechas(fechaInicio, fechaFin);
          this.crearMesResumen(dataProyectoResponse.idSprProyecto);
          this.crearParticipantes(
            dataProyectoResponse.idSprProyecto,
            this.formProyecto.value.fechaInicio,
            this.formProyecto.value.fechaFin
          );
          stateInsert = true;
          idSprProyectoInsertado = dataProyectoResponse.idSprProyecto;
          for (let idsArea of idsAreas) {
            let dataAreas = {
              idSprProyecto: dataProyectoResponse.idSprProyecto,
              idSprArea: idsArea.idSprArea,
              usuario: this.idSprUsuario,
              ip: this.ipAddress,
              estado: '1',
            };
            //Insertando areas-elemento
            this.areaELemService.create(dataAreas).subscribe(
              (dataAreaELemento) => {
                stateInsert = true;
              },
              (error) => {
                stateInsert = false;
              }
            );
          } // Fin for
          if (stateInsert) {
            this.participanteElementoService.create({
              idSprEquipoGerencial: this.formProyecto.value.idSprEquipoGerencial,
              fechaInicio: this.formProyecto.value.fechaInicio,
              fechaFin: this.formProyecto.value.fechaFin,
              usuario: this.idSprUsuario,
              idSprProyecto: idSprProyectoInsertado,
              estado: 1,
              ip: this.ipAddress,
            })
              .subscribe(
                (responseParticipaELement) => {
                  stateInsert = true;
                },
                (error) => {
                  stateInsert = false;
                }
              );
          }
          if (stateInsert) {
            this.alertService.createOk();
            this.modalEditClose();
            this.ngOnInit();
            this.clearCheckbox();
          } else {
            this.alertService.createError();
          }
          return true;
        },
        (err) => {
          stateInsert = false;
        }
      );
    } else {
      let idsAreasDeFormulario = this.opciones;
      this.formProyecto.value.ip = this.ipAddress;
      this.formProyecto.value.idSprAmbiente = this.idSprAmbiente;
      this.formProyecto.value.usuario = this.idSprUsuario;
      let dataFormulario = this.formProyecto.value;
      stateInsert = true;
      let idsAreasProyectosActuales;
      this.participanteElementoAeliminar.forEach((participante) => {
        this.participanteElementoService.delete(participante).subscribe();
      });
      this.participanteElementoAeliminar.forEach((participante) => {
        this.equipoGerencialService.actualizaEquipo(participante).subscribe();
      });
      this.comparaEditaResumenEjecutivo(this.resumenEjecutivoGuardado, this.resultadoFinalMesesInicioFin, this.formProyecto.value.idSprProyecto)

      this.crearParticipantes(this.formProyecto.value.idSprProyecto, this.formProyecto.value.fechaInicio, this.formProyecto.value.fechaFin);
      this.areaELemService.list(`?idSprProyecto=${this.formProyecto.value.idSprProyecto}&delLog=N&estado=1`).subscribe({
        next: (dataAreaElementosActuales) => {
          idsAreasProyectosActuales = dataAreaElementosActuales;
          // Actualizacion a la tabla proyectos
          this.proyectoService.update(dataFormulario).subscribe({
            next: (data) => {
              // Verificamos si existe areas nuevas q agregar
              /**igual aqui mejor traer lo seleccionado desde la base y comparla con lo seleccionado,
               * los que no estan en la base debo crear
               */
              for (let i = 0; i < idsAreasDeFormulario.length; i++) {
                for (let j = 0; j < idsAreasProyectosActuales.length; j++) {
                  if (idsAreasDeFormulario[i].checked == false &&
                    idsAreasProyectosActuales[j].idSprArea == idsAreasDeFormulario[i].idSprArea &&
                    idsAreasProyectosActuales[j].estado == 1) {
                    let dataAreasProyectoActualiza = {
                      idSprAreaElemento: idsAreasProyectosActuales[j].idSprAreaElemento,
                      delLog: 'S',
                      usuario: idSprUsuario,
                      ip: this.ipAddress,
                      estado: 1,
                    };
                    this.areaELemService.update(dataAreasProyectoActualiza).subscribe();
                  }
                }
                if (idsAreasDeFormulario[i].checked == true) {
                  let dataAtribucionObjetivoCreate = {
                    idSprProyecto: idSprProyecto,
                    idSprArea: idsAreasDeFormulario[i].idSprArea,
                    usuario: idSprUsuario,
                    ip: this.ipAddress,
                    estado: 1,
                  };
                  this.areaELemService.create(dataAtribucionObjetivoCreate).subscribe();
                }
              }
            },
            error: (err) => {
              stateInsert = false;
            },
          }); // Fin editHito proceso

          // Desabilitando responsable anterior
          if (this.formProyecto.value.idSprParticipanteElemento != null) {
            let dataParticipanteELemento = {
              idSprParticipanteElemento:
                this.formProyecto.value.idSprParticipanteElemento,
              idSprEquipoGerencial:
                this.formProyecto.value.idSprEquipoGerencial,
              fechaInicio: this.formProyecto.value.fechaInicio,
              fechaFin: this.formProyecto.value.fechaFin,
              usuario: idSprUsuario,
              ip: this.ipAddress,
              estado: 1,
            };
            // Deshabilitar el participante anterior
            this.participanteElementoService.update(dataParticipanteELemento).subscribe(
              (responseResponsable) => {
                this.initApp();
                //this.onResetForm();
                this.modalEditClose();
                this.alert.updateOk();
              },
              (err) => {
                this.alert.updateError();
              }
            );
          }
          // }
        },
        error: (err) => {
          //stateInsert = false;
          this.alertService.updateError();
        },
      });
    }
    // Fin else actualizar
  }


  validacionFechas(fechaInicial: Date, fechaFin: Date) {
    let alerta1
    if (fechaInicial > fechaFin) {
      alerta1 = this.alert.warning(
        '¡Atención!',
        'Fecha inicio no puede ser mayor a la fecha fin'
      );
      return alerta1
    }
  }


  /////////////METODO QUE TRAE DATOS DE PARTICIPANTESPARA EDITAR//////////
  getDataParticipanteElementoEditar(idSprProyecto: number) {
    this.participanteElementoService
      .list('?idSprProyecto=' + idSprProyecto)
      .subscribe((res: any) => {
        this.participanteElemento = res;
        let participanteElementoPatrocinador: any;
        this.inputsAnteriores = [];
        res.forEach((participante, index) => {
          this.equipoGerencialService.getById(participante.idSprEquipoGerencial).subscribe((resi: any) => {
            if (resi.idSprTipoParticipante === this.idSprComunEquipoProyectos) {
              this.inputsAnteriores.push({
                ...resi, participanteElemento: participante,
              });
            }
            if (
              index === 0 &&
              resi.idSprTipoParticipante !== this.idSprComunEquipoProyectos
            ) {
              this.patrocinadorOriginal = participante;
              participanteElementoPatrocinador = resi;
              this.guardarEquipoGerencialSeleccionado = resi;
              this.formProyecto.patchValue({
                ...this.formProyecto.value,
                idSprEquipoGerencial: resi.idSprEquipoGerencial,
                idSprParticipanteElemento: participante.idSprParticipanteElemento

              });
              // this.formProyecto.value.idSprEquipoGerencial = resi.idSprEquipoGerencial
              this.formProyecto.value.idSprParticipanteElemento = participante.idSprParticipanteElemento
              // this.idSprParticipanteElemento = participante.idSprParticipanteElemento;
            }
          });
        });
      });
  }

  areasEditar(obj) {
    this.areaELemService.list(`?idSprProyecto=${obj.idSprProyecto}&delLog=N`)
      .subscribe((response) => {
        this.dataAreasChecked = response;
        let vectorNuevo = [];
        this.areaServcie.list(`?idSprAmbiente=${this.idSprAmbiente}`).subscribe((resp) => {
          this.dataAreas = resp;
          for (let i = 0; i < this.dataAreasChecked.length; i++) {
            for (let j = 0; j < this.dataAreas.length; j++) {
              if (this.dataAreasChecked[i].idSprArea === this.dataAreas[j].idSprArea) {
                vectorNuevo.push({
                  idSprArea: this.dataAreas[j].idSprArea,
                  nombre: this.dataAreas[j].nombre,
                  idSprAreaElemento: this.dataAreas[j].idSprAreaElemento,
                });
                vectorNuevo = vectorNuevo.map((x: any) => {
                  x.isChecked = true;
                  return x;
                });
              }
            }
            this.vector1 = vectorNuevo;

            this.encontrarDiferencias(this.vector1, this.dataAreas);
          }
          //fin for
        });
      });
  }

  encontrarDiferencias(vector1, vector2) {
    this.elementosDiferentes = vector2.filter(
      (itemLista) =>
        !vector1.some((itemArea) => itemArea.idSprArea === itemLista.idSprArea)
    );
    this.elementosDiferentes.map((item) => item.idSprArea);
    this.elementosDiferentes = this.elementosDiferentes.map((x: any) => {
      x.isChecked = false;
      return x;
    });
    const nuevoVector = this.elementosDiferentes.map((item) => ({
      idSprArea: item.idSprArea,
      nombre: item.nombre,
      isChecked: item.isChecked,
      idSprAreaElemento: item.idSprAreaElemento,
    }));

    const vectorCombinado = vector1.concat(nuevoVector);
    this.dataAreasProcess = vectorCombinado;
  }

  edit(obj: any) {
    this.setDataAreasCheck(obj.areas)
    this.openModal();
    this.formProyecto.patchValue({
      idSprProyecto: obj.idSprProyecto,
      idSprObjetivo: obj.idSprObjetivo,
      idSprEstrategia: obj.idSprEstrategia,
      idSprViabilidadTecnica: obj.idSprViabilidadTecnica,
      idSprTipoProyecto: obj.idSprTipoProyecto,
      idSprTipoCliente: obj.idSprTipoCliente,
      idSprAmbiente: obj.idSprAmbiente,
      idSprArea: obj.idSprArea,
      idSprTitular: obj.idSprTitular,
      localidadImpacto: obj.localidadImpacto,
      nombreProyecto: obj.nombreProyecto,
      descripcion: obj.descripcion,
      fechaInicio: obj.fechaInicio,
      fechaFin: obj.fechaFin,
      beneficiosCualitativos: obj.beneficiosCualitativos,
      restricciones: obj.restricciones,
      numContratoPrincipal: obj.numContratoPrincipal,
      objetivoGeneral: obj.objetivoGeneral,
      objetivoEspecifico: obj.objetivoEspecifico,
      estado: obj.estado,
    });
    this.participantesNuevos = [];
    this.inputsAnteriores = [];
    this.seleccionados = [];
    let areasFixed = this.dataAreas;
    let checked: boolean = false;
    this.getDataParticipanteElementoEditar(obj.idSprProyecto);
    this.dataResumenEjecutivo(obj.idSprProyecto)
  }

  dataResumenEjecutivo(idSprProyecto: number) {
    this.resumenEjecutivoService.list(`?idSprProyecto=${idSprProyecto}&delLog=N`).subscribe(resp => {
      this.resumenEjecutivoGuardado = resp
    }
    )
  }

  delete(idRegister: number) {
    this.modal.open('delete-proyecto');
    this.idDeleteRegister = idRegister;
  }

  verifyIndicador() {
    return this.indicadorService
      .list(`?idSprProyecto=${this.idDeleteRegister}&delLog=N`)
      .toPromise();
  }

  verifyEtapa() {
    return this.etapaService
      .list(`?idSprProyecto=${this.idDeleteRegister}&delLog=N`)
      .toPromise();
  }

  verifyRiesgo() {
    return this.riesgoService
      .list(`?idSprProyecto=${this.idDeleteRegister}&delLog=N`)
      .toPromise();
  }

  async confirmDelete() {
    let errorDeleteState: boolean = false;
    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
    dataVerifyRelacion = await this.verifyIndicador();
    dataVerifyRelacion.length > 0 ? (confirmDelete = false) : '';
    dataVerifyRelacion = await this.verifyEtapa();
    dataVerifyRelacion.length > 0 ? (confirmDelete = false) : '';
    dataVerifyRelacion = await this.verifyRiesgo();
    dataVerifyRelacion.length > 0 ? (confirmDelete = false) : '';

    let dataDeleteAreElementos = {
      usuario: this.idSprUsuario,
      idSprAreaElemento: 0,
      ip: this.ipAddress,
      delLog: 'S',
    };

    let dataDeleteParticipElementos = {
      usuario: this.idSprUsuario,
      idSprParticipanteElemento: 0,
      ip: this.ipAddress,
      delLog: 'S',
    };
    let dataDeleteProyecto = {
      idSprProyecto: this.idDeleteRegister,
      usuario: this.idSprUsuario,
      ip: this.ipAddress,
      delLog: 'S',
    };
    if (confirmDelete) {
      this.objetivoService.list(
        `?idSprProyecto=${this.idDeleteRegister}&delLog=N`
      );
      this.estrategiaService.list(
        `?idSprProyecto=${this.idDeleteRegister}&delLog=N`
      );
      this.areaServcie.list(`?idSprProyecto=${this.idDeleteRegister}&delLog=N`);
      let areasELementos = [];
      let participantesElementos = [];
      this.participanteElementoService
        .list(`?idSprProyecto=${this.idDeleteRegister}`)
        .subscribe((response) => {
          participantesElementos = response;
          this.areaELemService
            .list(`?idSprProyecto=${this.idDeleteRegister}`)
            .subscribe((response) => {
              areasELementos = response;
              // Foreach 1
              areasELementos.forEach((itemAreaElement) => {
                dataDeleteAreElementos.idSprAreaElemento =
                  itemAreaElement.idSprAreaElemento;
                this.areaELemService.delete(dataDeleteAreElementos).subscribe({
                  next: (responseDelete) => { },
                  error: (error) => {
                    errorDeleteState = true;
                    errorDeleteState = true;
                    dataDeleteProyecto.delLog = 'N';
                    this.proyectoService.delete(dataDeleteProyecto).subscribe({
                      next: (responseDelete) => { },
                      error: (error) => {
                        errorDeleteState = true;
                      },
                    });
                  },
                });
              }); // Fin forEach 1
              // Foreach 2
              participantesElementos.forEach((itemParticipanteElement) => {
                dataDeleteParticipElementos.idSprParticipanteElemento =
                  itemParticipanteElement.idSprParticipanteElemento;
                this.participanteElementoService
                  .delete(dataDeleteParticipElementos)
                  .subscribe({
                    next: (responseDelete) => {
                      this.proyectoService
                        .delete(dataDeleteProyecto)
                        .subscribe({
                          next: (responseDelete) => { },
                          error: (error) => {
                            errorDeleteState = true;
                          },
                        });
                    },
                    error: (error) => {
                      errorDeleteState = true;
                      dataDeleteProyecto.delLog = 'N';
                      this.proyectoService
                        .delete(dataDeleteProyecto)
                        .subscribe({
                          next: (responseDelete) => { },
                          error: (error) => {
                            errorDeleteState = true;
                          },
                        });
                    },
                  });
              }); // Fin forEach 2
              this.participanteElementoService
                .list('?idSprProyecto' + this.idDeleteRegister)
                .subscribe((res) => {
                  res.forEach((participantesElemento) => {
                    this.participanteElementoService
                      .delete(participantesElemento)
                      .subscribe();
                  });
                });
            });
        });
      if (!errorDeleteState) {
        this.proyectoService.delete(dataDeleteProyecto).subscribe({
          next: (responseDelete) => { },
          error: (error) => {
            errorDeleteState = true;
          },
        });
      }
      if (!errorDeleteState) {
        this.alertService.deleteOk();
        this.modal.close();
        this.initApp();
      } else {
        this.alertService.deleteError();
      }
    } else {
      this.alertService.EliminarRegistro();
    }
  }


  getMonths(fechaInicio: String, fechaFin: String) {

    let fechaIni = new Date(fechaInicio.replace(/-/g, '/'));;
    let fechaFinal = new Date(fechaFin.replace(/-/g, '/'));;

    if (isNaN(fechaIni.getTime()) || isNaN(fechaFinal.getTime())) {
      console.error('Una o ambas fechas no son válidas.');
      return [];
    }

    const monthNames = [
      'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];

    this.resultadoFinalMesesInicioFin = [];

    if (fechaIni > fechaFinal) {
      return [];
    }

    fechaIni.setDate(1);

    while (fechaIni <= fechaFinal) {
      const subFechaFin = new Date(fechaIni.getFullYear(), fechaIni.getMonth() + 1, 15);
      const mesIndex = fechaIni.getMonth();
      const mesNombre = monthNames[mesIndex];
      this.resultadoFinalMesesInicioFin.push({
        subFechaInicio: this.formatDate(fechaIni),
        subFechaFin: this.formatDate(subFechaFin),
        mes: mesNombre,
        orden: mesIndex + 1
      });
      fechaIni.setMonth(fechaIni.getMonth() + 1);
    }
    return this.resultadoFinalMesesInicioFin;
  }

  // Función para formatear las fechas como 'dd-MM-yyyy'
  formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }


  crearMesResumen(idSprProyecto: number) {
    if (!this.resultadoFinalMesesInicioFin || this.resultadoFinalMesesInicioFin.length === 0) {
      console.error("No hay datos disponibles para procesar.");
      return;
    }
    const datosMesesResumen = this.resultadoFinalMesesInicioFin.map((mes, index) => ({
      idSprProyecto: idSprProyecto,
      nombre: mes.mes,
      fechaInicio: mes.subFechaInicio,
      fechaFin: mes.subFechaFin,
      orden: mes.orden,
      estado: 1,
      usuario: this.idSprUsuario,
      ip: this.ipAddress,
    }));

    datosMesesResumen.forEach(dataMesesResumen => {
      this.resumenEjecutivoService.create(dataMesesResumen).subscribe({
        next: (resp) => {
        },
        error: (err) => {
        }
      });
    });
  }

  comparaEditaResumenEjecutivo(a1: any[], a2: any[], idSprProyecto: number) {
    const eliminar = [];
    const editar = [];
    const crear = [];
    const a2Map = new Map<number, any>();
    a2.forEach(item => {
      a2Map.set(item.orden, item);
    });
    a1.forEach(item => {
      if (!a2Map.has(item.orden)) {
        eliminar.push(item);
      } else {
        editar.push(item);
        a2Map.delete(item.orden);
      }
    });

    a2Map.forEach(item => {
      crear.push(item);
    });

    if (eliminar.length > 0) {
      const dataEliminaResumen = eliminar.map((x: any) => {
        return { ...x, delLog: 'S' };
      });

      dataEliminaResumen.forEach(eliminaResumen => {
        this.resumenEjecutivoService.delete(eliminaResumen).subscribe({
          next: (resp) => { },
          error: (err) => {
            this.alertService.createError();
          },
        });
      });
    }

    if (crear.length > 0) {
      const dataCrearResumen = crear.map((mes: any) => ({
        idSprProyecto: idSprProyecto,
        nombre: mes.mes,
        fechaInicio: mes.subFechaInicio,
        fechaFin: mes.subFechaFin,
        orden: mes.orden,
        estado: 1,
        usuario: this.idSprUsuario,
        ip: this.ipAddress,
      }));

      dataCrearResumen.forEach(crearResumen => {
        this.resumenEjecutivoService.create(crearResumen).subscribe({
          next: (resp) => { },
        });
      });
    }
  }




  // Modal Crear/updatear
  openModal() {
    this.onResetForm();
    this.modal.open(this.nameModal);
    //this.dataAreasChecked = [];
    this.participantesNuevos = [];
    this.inputsAnteriores = [];
    this.setFormProyecto();
    this.limpiarLocalidadImpacto();
    //CODIGO PARA RESTABLECER EL SCROLL DE UN MODAL
    setTimeout(() => {
      // Verificar que la referencia al modal existe
      if (this.myModal) {
        const scrollableElement = this.myModal.element.querySelector(
          '.modal-dialog-scrollable .modal-body'
        );
        // Verificar que el elemento scrollable existe
        if (scrollableElement) {
          scrollableElement.scrollTop = 0;
        } else {
        }
      } else {
      }
    }, 200);
  }

  openModalEtapa() {
    this.onResetForm();
    this.modal.open(this.nameModal1);
  }

  openResumenEjecutivo() {
    this.onResetForm();
    this.modal.open(this.modalResumenEjecutivo);
  }

  modalEditClose() {
    this.modal.close();
    this.limpiarLocalidadImpacto()
    this.opciones = [];
    this.getAreas();
  }

  limpiarCheckbox() {
    this.isChecked = false;
    const checkboxes = document.getElementsByName('checkbox');
    checkboxes.forEach((checkbox: HTMLInputElement) => {
      checkbox.checked = false;
    });
  }

  clearCheckbox() {
    const inputs = document.getElementsByName('checkbox');
    inputs.forEach((i) => (i['checked'] = false));
  }
  // Resetear el formulario

  onResetForm() {
    this.formSubmitted = false;
    this.objetivoSeleccionadoCombo = null;
    this.dataAreasChecked = [];
  }

  limpiarLocalidadImpacto() {
    const miTextArea = document.getElementById('localidadImpacto') as HTMLTextAreaElement;
    miTextArea.value = "";
    this.nombreRuta = "";
  }

  addInput() {
    this.inputs.push({ nombre: '', cedula: '', idSprTipoParticipante: 0 });
  }

  removeInput(index: number) {
    this.participantesNuevos.splice(index, 1);
  }

}